export default "__VITE_ASSET__Co0t6rby__"